// extracted by mini-css-extract-plugin
module.exports = {"Container":"FilePreview_Container__1TYHp","label":"FilePreview_label__1i_16","modified":"FilePreview_modified__uVCQy"};